<template>
    <v-menu offset-y max-width="40%">
        <template v-slot:activator="{ on, attrs }">
            <a
                v-bind="attrs"
                v-on="on"
            >
                <div class="ml-3">
                    <v-icon color="red" size="22">mdi-alert</v-icon>
                </div>
            </a>
        </template>
        <div class="white">
            <div v-for="(message, index) in messages" :key = "index" class="v-flex">
                <div class="message-text" style="width: 220px">
                    {{ formatDateTime (message.received) }}
                </div>
                <div class="message-text">
                    {{ $t( message.errorId + ".message", parameters(message)) }}
                </div>
            </div>
        </div>
    </v-menu>
</template>

<script>

import Core from "@/modules/core/service/Core";
import DeviceTypeConflict from "@/modules/dis/service/inspection/DeviceTypeConflict";

export default {
    name: "PInspectionMessages",

    props: {
        messages: {

        }
    },

    methods: {
        /** Parameters of the message; the device type conflict with names instead of ids (HCIT-943). */
        parameters (message) {
            const siteTypes = this.$store.getters.msd ? this.$store.getters.msd.siteType : [];
            const parameters = DeviceTypeConflict.messageParameters(
                message, siteTypes, key => this.$t('disposition.inspection.deviceType.' + key));
            return parameters.length > 0 ? parameters : null;
        },

        formatDateTime (value) {
            return Core.format.datetime.display(value)
        }
    }
}
</script>

<style scoped>

.message-text {
    font-size: 14px;
    padding: 8px;
}

</style>